<template>
    <div id="mail-address-list">
        <div class="to-container" :style="label === 'to' ? 'height: auto' : ''">
            <div class="left">
                <div class="to">{{ getLabel() }}</div>
                <span class="selected-user-item row" v-for="selectedMember in selectedMembers">
                    {{ selectedMember }}
                    <span class="material-icons closeIcon" @click="deleteSelectedMailAddress(label, selectedMember)">
                        cancel
                    </span>
                </span>
                <input
                    v-model="mailValue"
                    class="mail-input"
                    :autofocus="true"
                    :disabled="label === 'from' && selectedMembers.length !== 0"
                    @input="getMailAddresses(label, $event, label === 'from')"
                    @keydown.down="selectDown()"
                    @keydown.up="selectUp()"
                    @keydown.enter="handleEnter"
                />
            </div>
            <div class="buttons" v-if="label === 'to'">
                <span class="item" @click="changeSelectedCcOrBcc('cc')" v-if="!selectedCC">CC</span>
                <span class="item" @click="changeSelectedCcOrBcc('bcc')" v-if="!selectedBCC">BCC</span>
            </div>
        </div>
        <div class="mail-options" id="mailOptions" v-if="mailAddressOptions.length > 0 && optionType === label">
            <div style="padding: 5px; height: fit-content; max-height: 45vh; overflow-y: auto">
                <div
                    v-for="(mailAddress, i) in mailAddressOptions"
                    :key="mailAddress._id"
                    style="padding: 5px; display: flex; align-items: center"
                    :class="
                        selectedIndex === i
                            ? 'active-mail-option-key'
                            : mailAddress.type !== 'seperator'
                            ? 'active-mail-option-hover'
                            : ''
                    "
                    @click="addItemOption(label, mailAddress.mail)"
                >
                    <div v-if="mailAddress.type === 'seperator'" class="mailAddressOptionsLabels">
                        {{ mailAddress.name }}
                    </div>
                    <div class="mail-list-avatar-wrapper">
                        <AgentAvatar v-if="!!mailAddress.user" :size="30" :user-i-d="mailAddress.user._id" />
                    </div>
                    <div class="avatar" v-if="!!mailAddress.department || !!mailAddress.visitor">
                        <span class="avatar-name">{{
                            mailAddress.mail ? mailAddress.mail.slice(0, 1).toUpperCase() : ""
                        }}</span>
                    </div>

                    <span v-if="mailAddress.type !== 'seperator'">{{ mailAddress.mail }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import { log2 } from "../../../utils/log2";
import Avatar from "vue-avatar";
import AgentAvatar from "../../../components/common/AgentAvatar.vue";

const log = log2("MailAddressList");
export default {
    name: "MailAddressList",
    components: {
        AgentAvatar,
        Avatar,
    },
    props: {
        label: {
            type: String,
            required: true,
        },
        defaultFromMember: {
            type: Array,
            required: false,
        },
        defaultToMember: {
            type: Array,
            required: false,
        },
    },
    data() {
        return {
            mailValue: "",
            selectedMembers: [],
            mailAddressOptions: [],
            selectedIndex: -1,
            optionType: "",
            selectedCC: false,
            selectedBCC: false,
        };
    },
    computed: {
        ...mapState({
            site: (state) => state.site.site,
            user: (state) => state.auth.user,
        }),
        ...mapGetters({}),
    },
    methods: {
        ...mapActions({
            getMailAddressesAction: "mail/getMailAddresses",
            getSenderMailAddressesByInput: "mail/getSenderMailAddressesByInput",
        }),
        getLabel() {
            let newLabel = this.label;
            console.log("this.label", this.label);
            if (this.label === "from") {
                newLabel = this.$t("mail.From");
            } else if (this.label === "to") {
                newLabel = this.$t("mail.To");
            }
            return newLabel.charAt(0).toUpperCase() + newLabel.slice(1) + ": ";
        },
        changeSelectedCcOrBcc(type) {
            if (type === "cc") {
                this.selectedCC = true;
            } else if (type === "bcc") {
                this.selectedBCC = true;
            }
            this.$emit("selectedCcOrBcc", type);
        },
        selectUp() {
            if (this.selectedIndex > -1) {
                this.selectedIndex -= 1;
                if (this.mailAddressOptions[this.selectedIndex].type === "seperator") {
                    this.selectedIndex -= 1;
                }
            }
        },
        selectDown() {
            if (this.selectedIndex < this.mailAddressOptions.length - 1) {
                this.selectedIndex += 1;
                if (this.mailAddressOptions[this.selectedIndex].type === "seperator") {
                    this.selectedIndex += 1;
                }
            }
        },
        deleteSelectedMailAddress(type, selectedItem) {
            if (type !== "from") {
                this.selectedMembers = this.selectedMembers.filter((item) => item !== selectedItem);
            } else if (type === "from") {
                this.selectedMembers = [];
            }
            this.$emit("selectedMembers", this.selectedMembers);
        },
        async getMailAddresses(type, e, isFrom = false) {
            if (e.target.value.length === 0) {
                this.mailAddressOptions = [];
                this.selectedIndex = -1;
                return;
            }
            if (e.target.value.length !== 0 && e.data !== " ") {
                this.mailAddressOptions = !isFrom
                    ? await this.getMailAddressesAction({
                          userId: this.user._id,
                          inputValue: e.target.value,
                          selectedMailAddress: this.selectedMembers,
                      })
                    : await this.getSenderMailAddressesByInput({
                          userId: this.user._id,
                          data: e.target.value,
                      });
                const userAddresses = this.mailAddressOptions.filter((x) => x.type === "user");
                const departmentAddresses = this.mailAddressOptions.filter((x) => x.type === "department");
                const visitorAddresses = this.mailAddressOptions.filter((x) => x.type === "visitor");
                let userMailAddress = [];
                let departmentMailAddress = [];
                let visitorMailAddress = [];
                if (userAddresses.length > 0) {
                    userMailAddress = [{ type: "seperator", name: "Kullanıcılar" }, ...userAddresses];
                }
                if (departmentAddresses.length > 0) {
                    departmentMailAddress = [{ type: "seperator", name: "Departmanlar" }, ...departmentAddresses];
                }
                if (visitorAddresses.length > 0) {
                    visitorMailAddress = [{ type: "seperator", name: "Ziyaretçiler" }, ...visitorAddresses];
                }
                this.mailAddressOptions = [...userMailAddress, ...departmentMailAddress, ...visitorMailAddress];
            }
            this.optionType = type;
            this.selectedIndex = -1;
        },
        addItemOption(type, value) {
            if (!value) {
                return;
            }
            if (type !== "from") {
                this.selectedMembers = [...this.selectedMembers, value];
                this.mailValue = "";
            } else if (type === "from") {
                this.selectedMembers = [value];
                this.mailValue = "";
            }
            this.mailAddressOptions = [];
            this.selectedIndex = -1;
            this.$emit("selectedMembers", this.selectedMembers);
        },
        handleEnter() {
            const value = this.mailAddressOptions[this.selectedIndex];
            console.log("handleEnter", { value, selectedIndex: this.selectedIndex });
            if (value) {
                this.selectedMembers = [...this.selectedMembers, value.mail];
            } else {
                this.selectedMembers =
                    this.mailValue.length > 0 ? [...this.selectedMembers, this.mailValue] : this.selectedMembers;
            }
            this.mailValue = "";
            this.selectedIndex = -1;
            this.mailAddressOptions = [];
            this.$emit("selectedMembers", this.selectedMembers);
        },
    },

    async mounted() {
        this.selectedMembers = !!this.defaultFromMember ? this.defaultFromMember : [];
        this.selectedMembers = !!this.defaultToMember && this.defaultToMember.length !== 0 ? this.defaultToMember : [];
        window.addEventListener("keydown", (e) => {
            if ("Escape" === e.key || "Esc" === e.key) {
                this.mailAddressOptions = [];
                this.selectedIndex = -1;
            }
        });

        document.addEventListener("click", (e) => {
            const mailOptions = document.getElementById("mail-address-list");
            if (!!mailOptions && !mailOptions.contains(e.target)) {
                this.handleEnter();
            }
        });
    },
    watch: {
        defaultFromMember() {
            this.selectedMembers = !!this.defaultFromMember ? this.defaultFromMember : [];
        },
        defaultToMember() {
            console.log("watch defaultToMember..", { a: this.defaultToMember, b: this.defaultToMember });
            this.selectedMembers =
                !!this.defaultToMember && this.defaultToMember[0].length !== 0 ? this.defaultToMember[0] : [];
        },
    },
};
</script>

<style lang="scss">
#mail-address-list {
    display: flex;
    flex-direction: column;
    width: 100%;
    position: relative;

    .to-container {
        display: flex;
        border-bottom: 1px solid #d0d9dd;
        justify-content: space-between;
        height: auto;
        padding: 5px;

        .left {
            display: flex;
            width: calc(100% - 150px);
            flex-wrap: wrap;
            grid-gap: 5px;
            gap: 5px;
            align-items: center;

            .to {
                padding-left: 10px;
                align-items: center;
                display: flex;
                justify-content: center;
            }

            .mail-input {
                border: none;
                width: inherit;
            }

            .selected-user-item {
                background-color: #3c92de;
                padding: 5px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                margin-left: 5px;
                margin-right: 0px;
                color: white;
                height: 30px;

                .closeIcon {
                    font-size: 15px;
                    margin-left: 5px;
                    color: white;
                    cursor: pointer;
                }
            }
        }

        .buttons {
            width: 70px;
            display: flex;
            grid-gap: 5px;
            gap: 5px;
            justify-content: flex-end;
            margin-right: 5px;

            .item {
                width: 100%;
                display: flex;
                align-items: center;
                cursor: pointer;
                color: black;
                justify-content: center;

                &:hover {
                    background-color: #e4e4e4;
                }
            }
        }
    }

    .mail-options {
        position: absolute;
        z-index: 999999;
        color: black;
        padding-top: 10px;
        width: 100%;
        top: 30px;
        border-radius: 5px;
        display: inline-table;
        background: #ffffff !important;
        border: 0.5px solid #cfcfcf;
        box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08), 0 3px 6px -4px rgba(0, 0, 0, 0.12),
            0 9px 28px 8px rgba(0, 0, 0, 0.05);

        .active-mail-option-hover {
            &:hover {
                cursor: pointer;
                background-color: #d5d2d2;
                border-radius: 10px;
            }
        }

        .active-mail-option-key {
            cursor: pointer;
            background-color: #d5d2d2;
            border-radius: 10px;
        }

        .close-options {
            display: flex;
            cursor: pointer;
            justify-content: end;
            margin-right: 10px;
            margin-bottom: -27px;
        }

        .mailAddressOptionsLabels {
            font-weight: 500;
            font-size: larger;
            margin: 5px 0 5px 0;
        }

        .avatar {
            margin-right: 10px;
            vertical-align: middle;
            width: 30px;
            height: 30px;
            border-radius: 25px;
            font-family: Helvetica, Arial, sans-serif;
            background-color: #8d5cc6;
            display: flex;
            justify-content: center;
            align-items: center;

            .avatar-name {
                font-size: medium;
                color: white;
                font-weight: 500;
            }
        }
    }
}

.mail-list-avatar-wrapper {
    max-width: 35px !important;
    height: 35px !important;
    margin-right: 10px !important;

    #avatar-placeholder {
        width: 33px !important;
        font-size: 16px !important;
    }
}
</style>
